import TsaRightsInfo from '@/components/copyright/business/copyrightDetail/rightsInfo'
import TsaBasicInfo from '@/components/copyright/business/copyrightDetail/basicInfo'
import TsaCreateProcess from '@/components/copyright/business/copyrightDetail/createProcess'
import TsaProductionTeam from '@/components/copyright/business/copyrightDetail/productionTeam'
import { downloadFile } from '@/common/copyright/fileUtil'
import { dramaDetailApi, findDramaStageFilesApi } from '@/api/copyright/drama'
import commonDetail from '@/mixins/detail'
import { mapActions,mapState } from 'vuex'
export default {
    components: {
        TsaRightsInfo,
        TsaBasicInfo,
        TsaCreateProcess,
        TsaProductionTeam
    },
    data () {
        return {
            id: this.$route.query.id,
        }
    },
    mixins: [ commonDetail ],
    computed: {
        ...mapState({
            parentIframe: (state) => state.app.parentIframe,
        }),
    },
    mounted () {
        this.updateDraftBoxCount()
        this.updateDramaBoxCount()
        this.init()
        document.body.addEventListener('touchstart', function() {}, true);
        // 处理滚动（相当于mouseleave）
        document.querySelector('.tsa-copyrightAuthSuccess').addEventListener('scroll', this.scrollBlur, false);
    },
    beforeDestroy () {
        this.customViewerApi && this.customViewerApi.hide()
        document.querySelector('.tsa-copyrightAuthSuccess').removeEventListener('scroll',this.scrollBlur);
    },
    methods: {
        scrollBlur(){
            if (document.activeElement) {
                document.activeElement.blur();
            }
        },
        ...mapActions({
            getBalanceInfo: 'balance/getBalanceInfo',
            updateDraftBoxCount: 'app/updateDraftBoxCount',
            updateDramaBoxCount: 'app/updateDramaBoxCount'
        }),
        init () {
            this.$TsaLoadingV2.show()
            dramaDetailApi(this.id).then((res) => {
                this.$TsaLoadingV2.hide()
                this.detailHandleData(res.data || {})
            }).catch((err) => {
                this.$TsaLoadingV2.hide()
            });
        },
        download () {
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightSuccess, {
                '操作类型': '详情_下载证书'
            })
            let {parentIframe} =this
            if(parentIframe === 'ANDROID-RIGHTS' || parentIframe === 'IOS-RIGHTS' || parentIframe === 'HARMONYOSNEXT-RIGHTS' || parentIframe ==='WEIXIN'){
                this.$TsaAlertV2.show({
                    title: '下载证书',
                    message: '请用手机浏览器打开后进行下载证书，或者在电脑端打开<span style="word-break: break-all;">https://ipr.tsa.cn/copyright/certifiedWork</span>下载证书。',
                    type: 'warn',
                    confirmButtonText: '我知道了',
                    onConfirm: () => {
                        this.$TsaAlertV2.hide()
                    },
                })
            }else{
                downloadFile(this.certificateInfo.certStorePathUrl)
            }
        },
        preview (url) {
            this.customViewerApi = this.$viewerApi({
                images: [url],
                options: {
                    title: false,
                    toolbar: false,
                    navbar: false,
                    button: false,
                    viewed() {
                        var that = this
                        document.querySelector('.viewer-container .viewer-canvas').onclick = function (e) {
                            if (e.target.className === 'viewer-canvas') {
                                that.viewer.hide()
                            }
                        }
                    }
                    // button: false
                }
            })
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightSuccess, {
                '操作类型': '查看证书'
            })
        },
        // 设置分享权限
        settingPermissionsCommon () {
            this.$refs.sharePermissionsSettingDialog.open({
                id: this.$route.query.id,
                rightsInfo: this.rightsInfo,
                basicInfo: this.basicInfo,
                certificateInfo: this.certificateInfo,
            })
        },
        // 设置访问权限
        settingPermissions () {
            // 从来没设置过分享权限
            if (this.basicInfo.setupStatus === 0) {
                this.settingPermissionsCommon()
            } else if (this.basicInfo.setupStatus === 1) {
                this.shareWorks()
            } else {
                this.$TsaToastV2.show({
                    message: '该作品设置访问权限失败',
                    type: 'error'
                })
            }
            
        },
        // 分享作品
        shareWorks () {
            this.$refs.shareWorksDialog.open({
                id: this.$route.query.id,
                rightsInfo: this.rightsInfo,
                basicInfo: this.basicInfo,
                certificateInfo: this.certificateInfo,
            })
        },
        // 分享设置成功
        permissionsSettingSuccess (obj) {
            this.$refs.sharePermissionsSettingDialog.hide()
            this.basicInfo.setupStatus = 1
            this.basicInfo.accessStatus = obj.accessStatus
            this.basicInfo.setupDuration = obj.setupDuration
            this.basicInfo.accessCode = obj.accessCode
            this.basicInfo.setupExpiredAt = obj.setupExpiredAt || null
            this.shareWorks()
        },
        loadAll (item) {
            let obj = item.children[item.children.length - 1]
            this.$TsaLoadingV2.show()
            findDramaStageFilesApi({
                lastDramaStageFileId: obj.id,
                stageId: obj.dramaStageId
            }).then(res => {
                this.$TsaLoadingV2.hide()
                let list = res.data || []
                item.children = [ ...item.children, ...list ]
            }).catch(() => {
                this.$TsaLoadingV2.hide()
            })
        },
        gotoIndex () {
            this.$router.push({
                path: '/copyright/index',
                query:{
                    redirect:'false'
                }
            })
        },
        actions ({ type }) {
            let textTrace = ''
            switch (type) {
                case 'downloadEvidence':
                    textTrace = '下载证据'
                    break
                case 'downloadCertificate':
                    textTrace = '下载证书'
                    break
                case 'downloadTsa':
                    textTrace = '下载tsa'
                    break
                case 'gotoDetail':
                    textTrace = '查看证据详情'
                    break
                case 'share':
                    textTrace = '分享证据'
                    break

            }
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightSuccess, {
                '操作类型': textTrace
            })
        }
    }
}